/** About page content - 1 Goss Consulting LLC */

export const ABOUT_FIRM = {
  legalName: '1 Goss Consulting LLC',
  headline: 'A practice built for executives under load.',
  founding:
    'Darryl Goss formed the firm to put that experience to work when organizations need a steady hand.',
  stats: [
    { value: '40 yrs', label: 'Experience' },
    { value: '25+', label: 'Years executive' },
    { value: 'Full P&L', label: 'Across the C-suite' },
  ],
};

export const ABOUT_DARRYL = {
  name: 'Darryl Goss',
  role: 'Principal',
  photo: '/brand/darryl-goss-on-cream.png?v=cream3',
  claim:
    'Known for steadying companies under pressure — strategy, operations, leadership, and performance that boards and buyers can trust.',
  blurb:
    'Transformational executive across healthcare, life sciences, and technology. CEO. President. COO. CIO. Forty years of experience, including 25+ in the C-suite.',
};

/**
 * Board / advisory affiliations.
 * Official logos need brand approval - UI shows name + note; drop files under
 * public/about/boards/ and set logo when ready.
 */
export const ABOUT_BOARDS = [
  {
    id: 'mayo',
    name: 'Mayo Clinic Laboratories',
    note: 'Board service',
    logo: null,
  },
  {
    id: 'pathgroup',
    name: 'PathGroup',
    note: 'Board service',
    logo: null,
  },
  {
    id: 'ucdavis',
    name: 'UC Davis',
    note: "Chancellor's Advisory Board",
    logo: null,
  },
  {
    id: 'acla',
    name: 'ACLA',
    note: 'Prior board service',
    logo: null,
  },
];

/** Kept for later — not shown on About until photos/copy are ready */
export const ABOUT_TEAM = [
  {
    id: 'dennis-brown',
    name: 'Dennis Brown',
    role: 'Engagement Lead',
    photo: null,
    years: '30+',
    blurb:
      'Engagement Lead with 30+ years in laboratory operations and technical architecture. Partners with Darryl on complex healthcare and lab engagements.',
  },
  {
    id: 'derrick-goss',
    name: 'Derrick Goss',
    role: 'Engagement Lead',
    photo: null,
    years: '30+',
    blurb:
      'Engagement Lead with 30+ years in project management and technical delivery. Keeps large, high-stakes programs moving with clarity, cadence, and follow-through.',
  },
];
